import { render, staticRenderFns } from "./reportQuestionAnswerDetailList.vue?vue&type=template&id=73714766&scoped=true"
import script from "./reportQuestionAnswerDetailList.vue?vue&type=script&lang=js"
export * from "./reportQuestionAnswerDetailList.vue?vue&type=script&lang=js"
import style0 from "./reportQuestionAnswerDetailList.vue?vue&type=style&index=0&id=73714766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73714766",
  null
  
)

export default component.exports